// extracted by mini-css-extract-plugin
export default {"icon":"style_icon__84zgX","title":"style_title__-ryQn","description":"style_description__uO6CI"};